import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {KnowledgeContentPage} from "./components/KnowledgeContentPage.tsx";

// Create a theme instance
const theme = createTheme({
  palette: {
    primary: {
      main: '#2e5cb8',
    },
    secondary: {
      main: '#646cff',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: 'Roboto, "Segoe UI", sans-serif',
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <KnowledgeContentPage />
    </ThemeProvider>
  </React.StrictMode>
);
